/**
 * Listens for HubSpot form events (all embed versions post a window message)
 * and pushes them to the GTM dataLayer.
 *
 * dataLayer events:
 *  - hubspot_form_submitted   (form data accepted by HubSpot)
 *  - book_demo_submitted      (only for the Book a demo forms)
 */

// Book a demo related HubSpot form IDs
const BOOK_DEMO_FORM_IDS = new Set([
  "737eb664-c3f6-4c61-834f-300ca3ddff05", // Book a demo (modal + /book-a-demo)
  "f5fcebb9-3547-4048-a9cb-a1a6feb3d37a", // Book a demo events
]);

type DataLayerWindow = Window & { dataLayer?: Record<string, unknown>[] };

const push = (event: Record<string, unknown>) => {
  const w = window as DataLayerWindow;
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push(event);
};

let initialized = false;

export const initHubSpotAnalytics = () => {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  window.addEventListener("message", (event: MessageEvent) => {
    const data = event.data as
      | { type?: string; eventName?: string; id?: string; formGuid?: string; data?: { formGuid?: string } }
      | undefined;
    if (!data || typeof data !== "object") return;
    if (data.type !== "hsFormCallback") return;

    const formId = data.id || data.formGuid || data.data?.formGuid || "";

    // onFormSubmitted fires when the thank-you message is shown
    if (data.eventName !== "onFormSubmitted") return;

    push({
      event: "hubspot_form_submitted",
      hubspot_form_id: formId,
      page_path: window.location.pathname,
    });

    if (BOOK_DEMO_FORM_IDS.has(formId)) {
      push({
        event: "form_submit",
        form_name: "book_a_demo",
      });
      push({
        event: "book_demo_submitted",
        hubspot_form_id: formId,
        page_path: window.location.pathname,
      });
    }
  });
};
